'use strict';

function dropdownInit() {
	var $dds = $('.custom-dd');

	$dds.each(function() {
		var $dd = $(this);
		var $ddContainer = $dd.find('.custom-dd-list-container');
		var $selectedOption = $ddContainer.find('.selected');
		var $selectedItem = $dd.find('.custom-dd-list-selected-content');

		$selectedItem.html($selectedOption.html());
		if ($selectedOption.hasClass('unselectable')) {
			$selectedItem.addClass('unselectable');
		} else {
			$selectedItem.removeClass('unselectable');
		}

		$ddContainer.scrollBox();
	});

	changeWidth();
}

function dropdownOpen($dd) {
	var $ddSelected = $dd.find('.custom-dd-list-item-selected');
	var $ddContainer = $dd.find('.custom-dd-list-container');

	$dd.addClass('opened');
	$dd.parents(".cart-mini-recommendations-tile").find(".product-tile").addClass("tile-dropdown-open");
	if ($('#quickview-modal .modal-body').hasClass('sb-container-noscroll')) {
		$('#quickview-modal .modal-body').addClass('custom-dd-noscroll');
	}
	$ddContainer.trigger("resize.scrollBox");

	$ddContainer.position({
		"my": "left top+10",
		"at": "left bottom",
		"of": $ddSelected,
		"collision": "flip flip"
	});
	changeWidth();
	if($(".cart-mini-recommendation-container").length) {
		$(".cart-mini-recommendations .slick-prev").hide();
	}
}

function dropdownClose($dd) {
	changeWidth();
	$dd.removeClass('opened');
	if ($('#quickview-modal .modal-body').hasClass('sb-container-noscroll')) {
		$('#quickview-modal .modal-body').removeClass('custom-dd-noscroll');
	}
	$dd.find('.custom-dd-list-container').trigger("resize.scrollBox");
	if($(".cart-mini-recommendation-container").length) {
        $(".cart-mini-recommendations .slick-prev").show();
    }
	setTimeout(function() {
		$dd.parents(".cart-mini-recommendations-tile").find(".product-tile").removeClass("tile-dropdown-open");
	}, 500);
}

function changeWidth() {
	if ($('.swatchanchor').find('.hexcode-unavailable').length > 0) {
		$('.unselectable').addClass('dynamic-width');
		$('.swatchanchor').addClass('dynamic-width');
	}
	if ($('.color-swatch').find('.hexcode-unavailable').length > 0) {
		$('.color-swatch').addClass('dynamic-width');
	}
	if ($('.custom-dd-list-item-selected').find('.hexcode-unavailable').length > 0) {
		$('.color-swatch').addClass('dynamic-width');
	}
	if ($('.selectable').find('.hexcode-unavailable').length > 0) {
		$('.selectable').addClass('dynamic-width');
	}
}

function dropdownSelectedItemClick() {
	$('.custom-dd:not(.custom-dd-disabled)').each(function() {
		var $currentDD = $(this);
		$currentDD.off().on('click', '.custom-dd-list-item-selected', function(e) {
			e.stopPropagation();
			var $dd = $(this).closest('.custom-dd');
			if ($dd.hasClass('opened')) {
				dropdownClose($dd);
			} else {
				dropdownOpen($dd);
			}
			changeWidth();
		});
	});
}

function dropdownListItemClick() {
	$('.custom-dd:not(.custom-dd-disabled)').on('click', '.custom-dd-list-item', function() {
		var $dd = $(this).closest('.custom-dd');
		var $selectedItem = $dd.find('.custom-dd-list-selected-content');

		if ($(this).hasClass('unselectable')) {
			$selectedItem.addClass('unselectable');
		} else {
			$selectedItem.removeClass('unselectable');
		}
		dropdownClose($dd);
		changeWidth();
	});
}

function dropdownCloseOnDocumentClick() {
	$(document).on("click", function(event) {
		$('.custom-dd:not(.custom-dd-disabled)').each(function() {
			var $dd = $(this);
			var $ddContainer = $dd.find('.custom-dd-list-container');
			if (!$dd.is(event.target) && $dd.has(event.target).length === 0 && $dd.hasClass('opened')) {
				dropdownClose($dd);
			}
		});
	});
}

var customDropdown = {
	init: function() {
		$('.quick-shop-panel .custom-dd').removeClass('custom-dd-disabled');
		dropdownInit();
		dropdownSelectedItemClick();
		dropdownListItemClick();
		dropdownCloseOnDocumentClick();
	}
};

export default customDropdown;